export const getLabelForValue = (value, list, defaultValue = '') => {
  return list.find((item) => item.value === value)?.label ?? defaultValue;
};

// Note: These are no longer used since we get the list from the backend now
// Note: Backend is currently missing the following: Halal, Kosher
export const dietaryOptions = [
  {
    value: 'vegetarian',
    label: 'Vegetarian',
  },
  {
    value: 'gluten',
    label: 'Gluten free',
  },
  {
    value: 'vegan',
    label: 'Vegan',
  },
  {
    value: 'dairy',
    label: 'Dairy free',
  },
  {
    value: 'pescatarian',
    label: 'Pescatarian',
  },
  {
    value: 'lactose',
    label: 'Lactose free',
  },
  {
    value: 'nuts',
    label: 'Nut allergy',
  },
  {
    value: 'kosher',
    label: 'Kosher',
  },
  {
    value: 'halal',
    label: 'Halal',
  },
  {
    value: 'other',
    label: '+ Add notes',
  },
];
